import React, { FormEvent, useCallback, useContext, useState } from "react";

import { Button } from "../Components/Base";
import { ProfileLayout } from "../Container/Layout";
import { Toast } from "../Utils";
import { TransactionPatchPassword } from "../Services/Transactions";
import { AuthContext } from "../Context";

const ChangePassword = () => {
  const { setToken } = useContext(AuthContext);

  // ======================================================================

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [oldPassword, setOldPassword] = useState<string>("");

  const [newPassword, setNewPassword] = useState<string>("");
  const [newPassword2, setNewPassword2] = useState<string>("");

  // ======================================================================

  const resetForm = () => {
    setOldPassword("");
    setNewPassword("");
    setNewPassword2("");
  };

  const isValid = useCallback(() => {
    return (
      oldPassword.length > 7 &&
      newPassword.length > 7 &&
      newPassword2.length > 7
    );
  }, [oldPassword, newPassword, newPassword2]);

  // ======================================================================

  const handleSubmitFrom = (e: FormEvent) => {
    e.preventDefault();
    if (isValid()) {
      if (newPassword === newPassword2) {
        setIsLoading(true);
        TransactionPatchPassword({
          new_password: newPassword,
          old_password: oldPassword,
        })
          .then(({ data: res }) => {
            if (res.transaction_status) {
              localStorage.setItem("Token", res.data!.token);
              setToken(res.data!.token);
              resetForm();
              Toast("success", res.message);
            } else {
              Toast("error", res.message);
            }
          })
          .finally(() => setIsLoading(false));
      } else {
        Toast("error", "رمز عبور جدید و تکرار آن تطابق ندارند");
      }
    }
  };

  // ======================================================================

  return (
    <ProfileLayout>
      <div className="card border mb-4">
        <div className="card-header border-bottom p-3">
          <h4 className="card-header-title mb-0">رمز عبور</h4>
        </div>
        <form onSubmit={handleSubmitFrom} className="card-body mt-3">
          <div className="mb-4 w-100">
            <div className="d-flex input-group w-100 gap-2 mb-3">
              <div className="flex-grow-1">
                <label className="form-label">رمز عبور فعلی</label>
                <div className="input-group">
                  <input
                    type="password"
                    className="form-control"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    placeholder="رمز عبور فعلی خود را وارد کنید"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex input-group w-100 gap-2 mb-3">
              <div className="flex-grow-1">
                <label className="form-label">رمز عبور جدید</label>
                <div className="input-group">
                  <input
                    type="password"
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="رمز عبور جدید خود را وارد کنید"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <label className="form-label">تکرار رمز عبور جدید</label>
                <div className="input-group">
                  <input
                    type="password"
                    className="form-control"
                    value={newPassword2}
                    onChange={(e) => setNewPassword2(e.target.value)}
                    placeholder="تکرار رمز عبور جدید خود را وارد کنید"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex w-100 justify-content-end mt-4">
              <Button
                text="تغییر رمز عبور"
                isLoading={isLoading}
                disabled={!isValid()}
                btnClass="btn w-100 btn-primary"
              />
            </div>
          </div>
        </form>
      </div>
    </ProfileLayout>
  );
};

export default ChangePassword;
